const APP_ICON_ALIASES = Object.freeze({
  'authority-management': 'tenant-nav-authority',
  'information-management': 'tenant-nav-market',
  'message-management': 'tenant-nav-market',
  'digital-market-web': 'tenant-nav-market',
  'fund-management': 'tenant-nav-transaction',
  'credit-management': 'tenant-nav-credit',
  'collection-management': 'tenant-nav-collection',
  'overseas-urge': 'tenant-nav-collection',
  'risk-management': 'tenant-nav-risk'
})

export function resolveAppIcon(appCode) {
  if (typeof appCode !== 'string') return ''
  const normalizedCode = appCode.trim()
  return APP_ICON_ALIASES[normalizedCode] || normalizedCode
}
